import { formatDate } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DestroyableMixin } from "apps-module/app/shared-library/mixins/destroyable.mixin";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { Subscription } from "rxjs";

import { DatesFilterOptions } from "./dates-filter-options.enum";

@Component({
    selector: "[pcg-ng-dates-filter]",
    templateUrl: "./dates-filter.component.html",
    providers: []
})
export class DatesFilterComponent extends DestroyableMixin(EmptyInstance) implements OnInit {
    public readonly DateFilterValues = DatesFilterOptions;
    public readonly customFromDateControl = new FormControl<string>(null);
    public readonly customToDateControl = new FormControl<string>(null);

    @Input("type")
    public set radioSetter(value: FormControl<DatesFilterOptions>) {
        this.radioControl = value;
    }

    @Input("fromDate")
    public set fromDateSetter(value: FormControl<string>) {
        this.fromDateControl = value;
    }

    @Input("toDate")
    public set toDateSetter(value: FormControl<string>) {
        this.toDateControl = value;
    }

    public radioControl = new FormControl<DatesFilterOptions>(DatesFilterOptions.All);
    public fromDateControl: FormControl<string> = null;
    public toDateControl: FormControl<string> = null;

    @Output()
    public onSubmit = new EventEmitter();

    public onValueChange: Subscription = null;

    public ngOnInit(): void {
        this.onValueChange = this.radioControl.valueChanges.subscribe((value: DatesFilterOptions) => this.setDateControls(value));

        if (this.radioControl.value === DatesFilterOptions.Custom) {
            this.customFromDateControl.setValue(this.fromDateControl.value);
            this.customToDateControl.setValue(this.toDateControl.value);
        }

        this.setDateControls(this.radioControl.value);
    }

    public submit(): void {
        if (this.radioControl.value === DatesFilterOptions.Custom) {
            this.fromDateControl.setValue(this.customFromDateControl.value);
            this.toDateControl.setValue(this.customToDateControl.value);
        }

        this.onSubmit.emit();
    }

    private setDateControls(value: DatesFilterOptions): void {
        const now = new Date();
        const format = "yyyy-MM-dd";
        const locale = "en";

        switch (value) {
            case DatesFilterOptions.ThisMonth:
                this.fromDateControl.setValue(formatDate(new Date(now.getFullYear(), now.getMonth(), 1), format, locale));
                this.toDateControl.setValue(formatDate(new Date(now.getFullYear(), now.getMonth() + 1, 0), format, locale));
                break;
            case DatesFilterOptions.LastMonth:
                this.fromDateControl.setValue(formatDate(new Date(now.getFullYear(), now.getMonth() - 1, 1), format, locale));
                this.toDateControl.setValue(formatDate(new Date(now.getFullYear(), now.getMonth(), 0), format, locale));
                break;
            case DatesFilterOptions.Last12Month:
                this.fromDateControl.setValue(formatDate(new Date(now.getFullYear() - 1, now.getMonth(), now.getDay()), format, locale));
                this.toDateControl.setValue(formatDate(new Date(now.getFullYear(), now.getMonth(), now.getDay()), format, locale));
                break;
            case DatesFilterOptions.Custom:
                this.fromDateControl.setValue(this.customFromDateControl.value);
                this.toDateControl.setValue(this.customToDateControl.value);
                break;
            case DatesFilterOptions.All:
            default:
                this.fromDateControl.reset();
                this.toDateControl.reset();
                break;
        }

        this.customFromDateControl.setValue(this.fromDateControl.value);
        this.customToDateControl.setValue(this.toDateControl.value);
    }
}
